/** @typedef {import('../types/anomalyTimeSeries.types').TimeSeriesDataPoint} TimeSeriesDataPoint */
/** @typedef {import('../types/anomalyTimeSeries.types').VisibleRange} VisibleRange */

/**
 * @param {TimeSeriesDataPoint[]} dataPoints
 * @param {VisibleRange|null} visibleRange
 */
export const sliceDataPoints = (dataPoints, visibleRange) => {
  if (!visibleRange || !dataPoints?.length) return dataPoints || [];
  const { from, to } = visibleRange;
  const start = from <= to ? from : to;
  const end = from <= to ? to : from;
  return dataPoints.filter((dp) => dp.period >= start && dp.period <= end);
};

/**
 * @param {TimeSeriesDataPoint[]} dataPoints
 * @param {string} period
 * @param {VisibleRange|null} currentRange
 * @param {boolean} isShiftClick
 * @returns {VisibleRange|null|string}
 */
export const handlePeriodRangeSelection = (dataPoints, period, currentRange, isShiftClick) => {
  if (!isShiftClick || !currentRange?.from) {
    return period;
  }
  return { from: currentRange.from, to: period };
};

/**
 * @param {string} periodA
 * @param {string} periodB
 * @returns {VisibleRange}
 */
export const buildRange = (periodA, periodB) => ({
  from: periodA <= periodB ? periodA : periodB,
  to: periodA <= periodB ? periodB : periodA,
});
